import { linearScale } from "@scrolly/renderer";
import type { SlideOptionsSerialized } from "@scrolly/post-types";

export interface SlidePosition {
    left: number | undefined;
    right: number | undefined;
    margin: number;
    width: number;
}

/* eslint-disable */
const detectDevice = () => {
    const isMobile = window.orientation > -1;
    return isMobile;
};

export const slidePositionBreakpoints = {
    ipad: 620,
    iframe: 615,
    laptop: 1600,
    tv: 3072,
};

const getMarginByScreenSize = (screenSize: number, margin: number) => {
    if (screenSize >= slidePositionBreakpoints.laptop || screenSize >= slidePositionBreakpoints.tv) {
        return margin * 3;
    }

    return margin;
};

export const responsiveMultiplier = (screenWidth: number) => {
    switch (true) {
        case screenWidth >= slidePositionBreakpoints.tv:
            return 3;

        case screenWidth >= slidePositionBreakpoints.laptop:
            return 2.11;

        default:
            return 1;
    }
};

export const getSlideFontSizeByScreenWidth = (screenWidth: number) => `${responsiveMultiplier(screenWidth)}em`;

const getMaxSlideWidth = (screenWidth: number, maxBoxWidth: number) => {
    //console.log("screenWidth: "  + screenWidth)
    //console.log("iframe breakpoint: "  + slidePositionBreakpoints.iframe)
    //console.log(window.innerWidth)

    if (screenWidth >= slidePositionBreakpoints.tv) {
        return 1675 + 60 * 2;
    } else if (screenWidth >= slidePositionBreakpoints.laptop) {
        return 615 + 60 * 2;
    } else if (screenWidth >= slidePositionBreakpoints.ipad && detectDevice()) {
        return 280;
    } else if (screenWidth >= slidePositionBreakpoints.iframe && !detectDevice()) {
        //console.log("iframe conditions")
        return 280;
    } else {
        return maxBoxWidth;
    }
    /*
    switch (true) {
      case screenWidth >= slidePositionBreakpoints.tv:
        // Base size, plus default padding
        return 1675 + 60 * 2

      case screenWidth >= slidePositionBreakpoints.laptop:
        // Base size, plus default padding
        return 615 + 60 * 2

      case screenWidth >= slidePositionBreakpoints.ipad:
        // Base size, plus default padding
        return 280

      case screenWidth >= slidePositionBreakpoints.iframe:
        // Base size, plus default padding
        return !detectDevice() ? 280 : maxBoxWidth

      default:
        return maxBoxWidth
    }
    */
};

const getMinSlideWidth = (screenWidth: number) => {
    if (screenWidth >= slidePositionBreakpoints.tv) {
        return 1000;
    } else if (screenWidth >= slidePositionBreakpoints.laptop) {
        return 615 + 60 * 2;
    } else if (screenWidth >= slidePositionBreakpoints.ipad && detectDevice()) {
        return 280;
    } else if (screenWidth >= slidePositionBreakpoints.iframe && !detectDevice()) {
        return 280;
    } else {
        return 300;
    }
    /*
    switch (true) {
      case screenWidth >= slidePositionBreakpoints.tv:
        return 1000

      case screenWidth >= slidePositionBreakpoints.laptop:
        return 615 + 60 * 2

      case screenWidth >= slidePositionBreakpoints.ipad:
        return 280

      case screenWidth >= slidePositionBreakpoints.iframe:
        // Base size, plus default padding
        return !detectDevice() ? 280 : 300

      default:
        return 300
    }
    */
};
/* eslint-enable */
export const calculateSlidePosition = (
    options: SlideOptionsSerialized,
    safeAreaSizeXRelative: number,
    width: number,
    maxWidth: number,
    minWidth: number,
    useMobile = false
) => {
    // needs to be fine-tuned
    //console.log("screenwidth: " + width)
    const horizontalAlignment = options.safeAreaXPosition;
    const absoluteHorizontalAlignment = Math.abs(horizontalAlignment);
    const isCentered = absoluteHorizontalAlignment < 20;
    const maxSizeForSafeArea =
        (1 - safeAreaSizeXRelative) * (isCentered ? 0.5 + absoluteHorizontalAlignment / 100 : 0.8);
    const minSize = getMinSlideWidth(width);
    const maxSize = getMaxSlideWidth(width, maxWidth);
    const textWidth = Math.min(Math.max(maxSizeForSafeArea * width, minSize), maxSize);

    const useMargin = textWidth > minWidth;
    const marginToUse = useMargin ? getMarginByScreenSize(width, options.margin) : 0;

    const left = Math.abs(horizontalAlignment + 50); // 50 %
    const fillerScaleX = linearScale([0, 100], [0, (1 - safeAreaSizeXRelative) * 100], { clamp: false });

    const slidePosition: SlidePosition = {
        left: 0,
        right: 0,
        margin: marginToUse,
        width: textWidth - marginToUse * 2,
    };

    const leftText = fillerScaleX(left) + safeAreaSizeXRelative * 100;
    const rightText = 100 - fillerScaleX(left);
    const leftTooLarge = (leftText / 100) * width + textWidth > width;
    const rightToolarge = (rightText / 100) * width + textWidth > width;

    // 50 %, 40 %, 60 %
    const fromLeft = left < 50;

    // align at safe area
    if (options.alignAtSafeArea) {
        if (fromLeft) {
            slidePosition.left = (leftText / 100) * width;
            slidePosition.right = undefined;
            if (leftTooLarge) {
                slidePosition.left = undefined;
                slidePosition.right = 0;
            }
        } else {
            slidePosition.left = undefined;
            slidePosition.right = (rightText / 100) * width;
            if (rightToolarge) {
                slidePosition.right = undefined;
                slidePosition.left = 0;
            }
        }
        // align at the outer frame
    } else {
        slidePosition.right = fromLeft ? 0 : undefined;
        slidePosition.left = fromLeft ? undefined : 0;
    }

    if (useMobile) {
        slidePosition.left = options.margin / 2;
        slidePosition.right = options.margin / 2;
        slidePosition.width = width - options.margin;
        slidePosition.margin = 0;
    }

    return slidePosition;
};
